import type { DataNode } from 'ant-design-vue/es/tree'
import { EProductsType } from './types'
export const getInitTreeData = (): DataNode[] => [
  { title: '图书商品', commodityType: EProductsType.BOOKS, key: '1', isLeaf: false, selectable: false },
  { title: '非图商品', commodityType: EProductsType.NOT_BOOKS, key: '2', isLeaf: false, selectable: false },
  { title: '组合商品', commodityType: EProductsType.COMBINATION, key: '3', isLeaf: false, selectable: false },
  { title: '加工商品', commodityType: EProductsType.MACHINING, key: '4', isLeaf: false, selectable: false },
  { title: '卡券商品', commodityType: EProductsType.CARD_COUPONS, key: '5', isLeaf: false, selectable: false },
  { title: '服务商品', commodityType: EProductsType.SERVICE, key: '6', isLeaf: false, selectable: false },
  { title: '虚拟商品', commodityType: EProductsType.FICTITIOUS, key: '7', isLeaf: false, selectable: false },
]
export const levelOneKeys = getInitTreeData().map((i) => i.key)

export const productsNameDictionary = {
  [EProductsType.BOOKS]: '图书商品',
  [EProductsType.NOT_BOOKS]: '非图商品',
  [EProductsType.MACHINING]: '加工商品',
  [EProductsType.COMBINATION]: '组合商品',
  [EProductsType.SERVICE]: '服务商品',
  [EProductsType.CARD_COUPONS]: '卡券商品',
  [EProductsType.FICTITIOUS]: '虚拟商品',
}

// 权限
export const commodityButtonAuth = {
  [EProductsType.BOOKS]: {
    see: 'api:commodity:book:*:selectCommodityBookDetail',

    editBasicSave: 'api:commodity:book:*:updateBook',
    editImageTextSaveSingle: 'api:commodity:book:*:updateBook',
    editImageTextSaveMultiple: 'api:commodity:book:*:updateBook',
  },
  [EProductsType.NOT_BOOKS]: {
    see: 'api:commodity:noBook:*:selectCommodityNoBookDetail',
    addBasic: 'api:commodity:noBook:*:batchSaveSubmitBasicInformation', // 创建 基本信息 批量提交并新建
    addImageTextSingle: 'api:commodity:noBook:*:saveSubmit', // 创建 图文信息 提交并新建
    addImageTextMultiple: 'api:commodity:noBook:*:batchSaveSubmit', // 创建 图文信息 批量提交并新建
    editBasicSave: 'api:commodity:noBook:*:batchUpdateBasicInformation', // 修改 基本信息 批量保存
    editBasicSubmit: 'api:commodity:noBook:*:batchUpdateSubmitBasicInformation', // 修改 基本信息 批量提交 --非图才有
    editImageTextSaveSingle: 'api:commodity:noBook:*:update', // 修改 图文信息 保存
    editImageTextSaveMultiple: 'api:commodity:noBook:*:batchUpdate', // 修改 图文信息 批量保存
    editImageTextSubmitSingle: 'api:commodity:noBook:*:updateSubmit', // 修改 图文信息 提交 --非图才有
    editImageTextSubmitMultiple: 'api:commodity:noBook:*:updateUpdateSubmit', // 修改 图文信息 批量提交  --非图才有
  },
  [EProductsType.MACHINING]: {},
  [EProductsType.COMBINATION]: {
    see: 'api:commodity:combination:*:selectCommodityCombinationDetail',
    addBasic: 'api:commodity:combination:*:batchSaveSubmitBasicInformation', // 创建 基本信息 批量提交并新建
    addImageTextSingle: 'api:commodity:combination:*:saveSubmit', // 创建 图文信息 提交并新建
    addImageTextMultiple: 'api:commodity:combination:*:batchSaveSubmit', // 创建 图文信息 批量提交并新建
    editBasicSave: 'api:commodity:combination:*:batchUpdateBasicInformation', // 修改 基本信息 批量保存
    editImageTextSaveSingle: 'api:commodity:combination:*:update', // 修改 图文信息 保存
    editImageTextSaveMultiple: 'api:commodity:combination:*:batchUpdate', // 修改 图文信息 批量保存
  },
  [EProductsType.SERVICE]: {
    see: 'api:commodity:assist:*:selectCommodityAssistDetail',
    addBasic: 'api:commodity:assist:*:batchAssistSaveSubmitBasicInformation', // 创建 基本信息 批量提交并新建
    addImageTextSingle: 'api:commodity:assist:*:saveAssistSubmit', // 创建 图文信息 提交并新建
    addImageTextMultiple: 'api:commodity:assist:*:batchAssistSaveSubmit', // 创建 图文信息 批量提交并新建
    editBasicSave: 'api:commodity:assist:*:batchAssistUpdateBasicInformation', // 修改 基本信息 批量保存
    editImageTextSaveSingle: 'api:commodity:assist:*:updateAssist', // 修改 图文信息 保存
    editImageTextSaveMultiple: 'api:commodity:assist:*:batchAssistUpdate', // 修改 图文信息 批量保存
  },
  [EProductsType.CARD_COUPONS]: {
    see: 'api:commodity:cardCoupon:*:detail',
    addBasic: 'api:commodity:cardCoupon:*:batchAddBasicInformation', // 创建 基本信息 批量提交并新建
    addImageTextSingle: 'api:commodity:cardCoupon:*:addText', // 创建 图文信息 提交并新建
    addImageTextMultiple: 'api:commodity:cardCoupon:*:batchAddText', // 创建 图文信息 批量提交并新建
    editBasicSave: 'api:commodity:cardCoupon:*:batchUpdateBasicInformation', // 修改 基本信息 批量保存
    editImageTextSaveSingle: 'api:commodity:cardCoupon:*:updateText', // 修改 图文信息 保存
    editImageTextSaveMultiple: 'api:commodity:cardCoupon:*:batchUpdateText', // 修改 图文信息 批量保存
  },
  [EProductsType.FICTITIOUS]: {
    see: 'api:commodity:fictitious:*:selectCommodityFictitiousDetail',
    addBasic: 'api:commodity:fictitious:*:batchFictitiousSaveSubmitBasicInformation', // 创建 基本信息 批量提交并新建
    addImageTextSingle: 'api:commodity:fictitious:*:saveFictitiousSubmit', // 创建 图文信息 提交并新建
    addImageTextMultiple: 'api:commodity:fictitious:*:batchFictitiousSaveSubmit', // 创建 图文信息 批量提交并新建
    editBasicSave: 'api:commodity:fictitious:*:batchFictitiousUpdateBasicInformation', // 修改 基本信息 批量保存
    editImageTextSaveSingle: 'api:commodity:fictitious:*:updateFictitious', // 修改 图文信息 保存
    editImageTextSaveMultiple: 'api:commodity:fictitious:*:batchFictitiousUpdate', // 修改 图文信息 批量保存
  },
}
